import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2 } from 'lucide-react';
export function TomosSection() {
  const scrollToOffer = () => {
    const offerSection = document.getElementById('oferta');
    if (offerSection) {
      offerSection.scrollIntoView({
        behavior: 'smooth'
      });
    }
  };
  const tomos = [{
    number: '01',
    title: 'LÍNEA HERRERO COMPLETA',
    emoji: '📘',
    borderColor: 'border-blue-500',
    description: 'Dominá la línea más vendida. Aprendé a fabricar ventanas corredizas, paños fijos y puertas con precisión milimétrica.',
    highlight: '✅ Incluye tabla de descuentos actualizada 2024'
  }, {
    number: '02',
    title: 'LÍNEA MÓDENA — DE CERO A PROFESIONAL',
    emoji: '📗',
    borderColor: 'border-green-500',
    description: 'El salto de calidad que tu taller necesita. Secretos de armado a 45° y 90°, mecanizados y punzonados correctos.',
    highlight: '✅ Incluye guía de herrajes y cierres'
  }, {
    number: '03',
    title: 'LÍNEA A30 — EL NIVEL SUPERIOR',
    emoji: '📙',
    borderColor: 'border-orange-500',
    description: 'Entrá al mercado premium. Todo sobre perfiles pesados, refuerzos, y armado de aberturas de grandes dimensiones.',
    highlight: '✅ Incluye cálculo de vidrio DVH paso a paso'
  }, {
    number: '04',
    title: 'SISTEMA DE CORTES Y CÁLCULO',
    emoji: '📕',
    borderColor: 'border-red-500',
    description: 'Optimizá tus tiras de 6 metros al máximo. Fórmulas exactas para no desperdiciar ni un centímetro de aluminio.',
    highlight: '✅ Incluye planilla de lista de cortes imprimible'
  }, {
    number: '05',
    title: 'PRESUPUESTACIÓN PROFESIONAL',
    emoji: '📓',
    borderColor: 'border-purple-500',
    description: 'Dejá de cobrar a ojo. Aprendé a calcular costos directos, indirectos y tu margen de ganancia real para cada trabajo.',
    highlight: '✅ Incluye modelo de presupuesto editable'
  }, {
    number: '06',
    title: 'INSTALACIÓN Y TERMINACIONES PRO',
    emoji: '📔',
    borderColor: 'border-amber-700',
    description: 'El trabajo no termina en el taller. Técnicas de sellado, fijación y nivelación para que el cliente quede fascinado.',
    highlight: '✅ Incluye checklist de instalación imprimible'
  }];
  return <section className="bg-[#0A0A0A] py-24 px-4" data-id="element-304">
      <div className="container mx-auto max-w-6xl" data-id="element-305">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.4
      }} className="text-center mb-16" data-id="element-306">
          <h2 className="text-3xl md:text-5xl font-bold text-white mb-4" data-id="element-307">
            Todo lo que incluye el Super Combo
          </h2>
          <p className="text-[#D4A017] text-xl font-medium" data-id="element-308">
            6 tomos técnicos diseñados para el carpintero argentino
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-16" data-id="element-309">
          {tomos.map((tomo, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.4,
          delay: index * 0.1
        }} className={`bg-[#111111] rounded-xl p-8 border-l-4 ${tomo.borderColor} shadow-lg hover:bg-[#151515] transition-colors relative overflow-hidden`} data-id="element-310">
              <div className="absolute -top-6 -right-6 text-8xl font-black text-white/5 select-none" data-id="element-311">
                {tomo.number}
              </div>

              <div className="relative z-10" data-id="element-312">
                <div className="flex items-center gap-3 mb-4" data-id="element-313">
                  <span className="text-3xl" data-id="element-314">{tomo.emoji}</span>
                  <h3 className="text-xl font-bold text-white tracking-wide" data-id="element-315">
                    TOMO {tomo.number}: {tomo.title}
                  </h3>
                </div>

                <p className="text-gray-400 text-base leading-relaxed mb-6 min-h-[4.5rem]" data-id="element-316">
                  {tomo.description}
                </p>

                <div className="bg-black/50 rounded-lg p-3 border border-gray-800" data-id="element-317">
                  <p className="text-[#D4A017] font-medium text-sm flex items-start gap-2" data-id="element-318">
                    {tomo.highlight}
                  </p>
                </div>
              </div>
            </motion.div>)}
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.4
      }} className="flex justify-center" data-id="element-319">
          <button onClick={scrollToOffer} className="bg-[#D4A017] hover:bg-[#b58812] text-black font-black text-lg md:text-xl py-4 px-10 rounded-xl shadow-[0_0_20px_rgba(212,160,23,0.3)] transition-all transform hover:scale-105" data-id="element-320">
            🔥 QUIERO LOS 6 TOMOS AHORA →
          </button>
        </motion.div>
      </div>
    </section>;
}